<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12" class="mb-5">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_request_observations') }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :label="$t('transfer_observations')"
            dense
            autocomplete="nope"
            v-model="clientRequest.permanentInstruction.bnfReference"
            maxlength="128"
            :disabled="clientRequest.permanentInstruction.accountType == 'nfiAccount'"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :label="$t('transfer_instructions')"
            dense
            autocomplete="nope"
            v-model="clientRequest.permanentInstruction.avsInternalRemark"
            maxlength="128"
            :disabled="clientRequest.permanentInstruction.accountType == 'nfiAccount'"
            hide-details="auto"
          />
        </v-col>
      </v-row>
      <v-row v-if="requiredAuthDocument">
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            {{ $t('transfer_request_authorization_file_title') }} {{ '*' }}
          </div>
          <p class="mb-2">
            {{ $t('transfer_request_authorization_file_description') }}
          </p>
          <ul class="mb-2">
            <li>{{ $t('transfer_request_authorization_file_item_1') }}</li>
            <li>{{ $t('transfer_request_authorization_file_item_2') }}</li>
            <li>{{ $t('transfer_request_authorization_file_item_3') }}</li>
            <!-- <li>{{ $t('transfer_request_authorization_file_item_4') }}</li> -->
            <li>{{ $t('transfer_request_authorization_file_item_5') }}</li>
          </ul>
          <ValidationProvider
            vid="auth_doc"
            :name="$t('transfer_request_authorization_document')"
            rules="required|ext:pdf|size:5000"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="file"
              accept=".pdf"
              dense
              show-size
              outlined
              class="pt-2"
              :label="$t('transfer_request_authorization_document_upload')"
              @change="handleFile($event)"
              @click:clear="clearInputFile()"
              :error-messages="errors[0]"
              hide-details="auto"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
      <!-- Third party authorization file -->
      <v-row v-if="isThirdParty">
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            {{ $t('transfer_request_auth_third_party_file_title') }}
            {{ '*' }}
          </div>
          <p class="mb-2">
            {{ $t('transfer_request_auth_third_party_file_description') }}
          </p>
          <ul class="mb-2">
            <li>{{ $t('transfer_request_auth_third_party_file_item_1') }}</li>
            <li>{{ $t('transfer_request_auth_third_party_file_item_2') }}</li>
            <li>{{ $t('transfer_request_auth_third_party_file_item_3') }}</li>
          </ul>
          <ValidationProvider
            vid="third_party_doc"
            :name="$t('transfer_request_auth_third_party_document')"
            rules="required|ext:pdf|size:5000"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="thirdPartyFile"
              accept=".pdf"
              dense
              show-size
              outlined
              class="pt-2"
              :label="$t('transfer_request_auth_third_party_document_upload')"
              @change="handleThirdPartyFile($event)"
              @click:clear="clearInputThirdPartyFile()"
              :error-messages="errors[0]"
              hide-details="auto"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import { mapState } from 'vuex'
export default {
  components: {
    WizardForm
  },
  props: {
    clientRequest: {
      type: [Object]
    }
  },
  data() {
    return {
      file: null,
      thirdPartyFile: null,
      checkbox: false,
      stepTwo: {
        account_type: 'Cuentas de Bancos en Panamá'
      },
      items: [
        'Cuenta Corriente en Banco',
        'Cuenta Ahorro en Banco',
        'Cuenta Inversión en Institución Financiera no Banco'
      ],
      banks: ['Banco Mercantil', 'Banesco'],
      rules: [
        value =>
          !value ||
          value.size < 3000000 || // Size on Bytes
          `El archivo debe pesar menos de 3MB`
      ]
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('account', ['account', 'authorityAccounts']),
    isExecutive() {
      return (
        this.user?.authorityLevelsCode === 1 ||
        this.user?.authorityLevelsCode === 2 ||
        this.user?.authorityLevelsCode === 4
      )
    },
    isThirdParty() {
      return this.clientRequest?.permanentInstruction?.isThirdParty
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    },
    requiredAuthDocument() {
      return (
        this.isExecutive &&
        !this.isAccountCode &&
        this.clientRequest?.instructionType ===
          'transfer_request_new_instruction'
      )
    }
  },
  methods: {
    handleFile(file) {
      if (!file) {
        this.clientRequest.authorizationFile = null
        return
      }
      const reader = new FileReader()
      reader.onloadend = () => {
        this.clientRequest.authorizationFile = reader.result
      }
      reader.readAsDataURL(file)
    },
    handleThirdPartyFile(file) {
      if (!file) {
        this.clientRequest.thirdPartyAuthorizationFile = null
        return
      }

      const reader = new FileReader()
      reader.onloadend = () => {
        this.clientRequest.thirdPartyAuthorizationFile = reader.result
      }
      reader.readAsDataURL(file)
    },
    clearInputFile() {
      this.file = null
    },
    clearInputThirdPartyFile() {
      this.thirdPartyFile = null
    }
  }
}
</script>
<style scoped>
.main-container {
  line-height: normal;
}

hr {
  margin: 0;
  padding: 0;
}

hr.rounded {
  border-top: 2px solid;
  width: 400px;
}
</style>
